
import { supabase } from "@/lib/supabase";
import { useMemo } from 'react';

interface ChatMessageProps {
  type: 'user' | 'ai';
  content: string;
  isAuthenticated?: boolean;
  isReadyToSchedule?: boolean;
  parsedMeeting?: {
    dateTime: Date | null;
    attendeeName: string | null;
    duration?: number;
  } | null;
  onGoogleSignIn?: () => void;
  onSchedule?: () => void;
}

const GoogleIcon = () => (
  <svg 
    className="w-5 h-5" 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#fff"
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
    />
    <path
      fill="#fff"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
    />
    <path
      fill="#fff"
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
    />
    <path
      fill="#fff"
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
    />
  </svg>
);

const ChatMessage = ({ 
  type, 
  content,
  isAuthenticated,
  isReadyToSchedule,
  parsedMeeting,
  onGoogleSignIn,
  onSchedule 
}: ChatMessageProps) => {
  
  console.log('ChatMessage render with props:', {
    type,
    content,
    isAuthenticated,
    isReadyToSchedule,
    parsedMeeting: parsedMeeting ? {
      dateTime: parsedMeeting.dateTime?.toISOString(),
      attendeeName: parsedMeeting.attendeeName,
      duration: parsedMeeting.duration
    } : null
  });

  const formattedMessage = useMemo(() => {
    if (type !== 'ai') return <p className="text-sm">{content}</p>;

    const showSignInButton = !isAuthenticated && 
                           parsedMeeting?.dateTime && 
                           parsedMeeting?.attendeeName;

    console.log('Evaluating Sign In button:', {
      showButton: showSignInButton,
      isAuthenticated,
      hasDateTime: !!parsedMeeting?.dateTime,
      hasAttendeeName: !!parsedMeeting?.attendeeName
    });

    return (
      <div className="space-y-4">
        <p className="text-sm">{content}</p>
        {showSignInButton && onGoogleSignIn && (
          <button
            onClick={onGoogleSignIn}
            className="flex items-center justify-center gap-2 w-full bg-[#4285F4] hover:bg-[#3367D6] text-white font-medium py-3 px-4 rounded-lg transition-colors"
          >
            <GoogleIcon />
            Sign In & Schedule Meeting
          </button>
        )}
      </div>
    );
  }, [type, content, isAuthenticated, parsedMeeting, onGoogleSignIn]);

  return (
    <div className={`flex ${type === 'user' ? 'justify-end' : 'justify-start'} max-w-2xl mx-auto w-full mb-4`}>
      <div className={`max-w-[80%] ${type === 'user' ? 'ml-auto' : 'mr-auto'}`}>
        <div 
          className={`rounded-lg p-4 shadow-lg ${
            type === 'user' 
              ? 'bg-[#4285F4] text-white' 
              : 'bg-[#2A2A2A] text-white border border-[#3A3A3A]'
          }`}
        >
          {formattedMessage}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
